import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/fontawesome-free-solid';

const LoadingButton = props => {
  const { disabled, className, loading, loadingText, ...other } = props;
  const mergedClassNames = `btn btn-primary btn-block ${className}`.trim();

  if (props.loading) {
    let child = <FontAwesomeIcon icon={faSpinner} spin />;
    if (props.loadingText.length > 0) {
      child = props.loadingText;
    }
    return (
      <button {...other} className={mergedClassNames} type="submit" disabled="true">
        {child}
      </button>
    );
  }

  return (
    <button {...other} className={mergedClassNames} type="submit" disabled={disabled}>
      {props.children}
    </button>
  );
};

LoadingButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  className: PropTypes.string,
  loadingText: PropTypes.string
};

LoadingButton.defaultProps = {
  disabled: false,
  loading: false,
  className: '',
  loadingText: ''
};

export default LoadingButton;



// WEBPACK FOOTER //
// ./src/modules/misc/components/LoadingButton.js